import React from "react";
import { Input } from "@/components/ui/input";

interface LabeledFileInputProps {
  containerClassName?: string;
  id: string;
  label?: React.ReactNode;
  accept?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  currentFileId?: string;
  selectedFile?: File;
  currentFileText?: string;
  newFileSelectedText?: string;
}

const LabeledFileInput: React.FC<LabeledFileInputProps> = ({
  containerClassName,
  id,
  label,
  accept,
  onChange,
  currentFileId,
  selectedFile,
  currentFileText,
  newFileSelectedText,
}) => {
  return (
    <div className={containerClassName}>
      {label && <label htmlFor={id} className="text-sm font-medium">{label}</label>}
      <Input id={id} type="file" accept={accept} onChange={onChange} />
      {currentFileId && !selectedFile && currentFileText && (
        <p className="text-sm text-gray-600 mt-1">{currentFileText}</p>
      )}
      {selectedFile && (
        <p className="text-sm text-green-600 mt-1">
          {newFileSelectedText}
          {newFileSelectedText ? ": " : ""}
          {selectedFile.name}
        </p>
      )}
    </div>
  );
};

export default LabeledFileInput;
